(() => {
  document.body.classList.add('ow-trade-partner-page');

  const formWrap = document.querySelector('[data-trade-partner-form]');
  if (!formWrap) return;

  const form = formWrap.querySelector('form');
  const params = new URLSearchParams(window.location.search);
  const publish = (event, details = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...details });
  };

  const attribution = {
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
    referrer_host: (() => {
      try { return document.referrer ? new URL(document.referrer).hostname : 'direct'; }
      catch { return 'direct'; }
    })(),
    landing_page: window.location.pathname
  };

  Object.entries(attribution).forEach(([key, value]) => {
    const input = formWrap.querySelector(`[data-partner-attribution="${key}"]`);
    if (input) input.value = String(value).slice(0, 180);
  });

  document.querySelectorAll('[data-partner-cta]').forEach((cta) => {
    cta.addEventListener('click', () => {
      publish('trade_partner_cta_click', { partner_cta: cta.dataset.partnerCta || 'unknown' });
    });
  });

  form?.addEventListener('submit', () => {
    const role = form.querySelector('[name="contact[primary_role]"]');
    publish('trade_partner_application_submit_attempt', {
      partner_role: role?.value || 'not-selected'
    });
  });

  const status = formWrap.querySelector('.ow-partner-status');
  if (status) {
    requestAnimationFrame(() => {
      status.scrollIntoView({ behavior: 'smooth', block: 'center' });
      status.focus({ preventScroll: true });
    });
  }
})();
